module.exports = __webpack_public_path__ + "img/homelogo.f68438c3.png";